import axios from "../api/axios";

export const UpdateSubscription = async (userId, Email, newPlanType) => {
  try {
    const response = await axios.post("/stripe/update-subscription", {
      userId: userId,
      Email: Email,
      newPlanType: newPlanType
    });
    return response;
  } catch (error) {
    throw error;
  }
};